var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9648 12.0439C11.3446 12.0439 11.6523 12.3518 11.6523 12.7314V15.1404C11.6523 15.5201 11.3446 15.8279 10.9648 15.8279C10.5852 15.8279 10.2773 15.5201 10.2773 15.1404V12.7314C10.2773 12.3518 10.5852 12.0439 10.9648 12.0439Z",
    fill: "#F7A303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03449 10.1268C2.25224 9.81578 2.68091 9.74006 2.99197 9.95786L3.00278 9.96538C5.1005 11.2532 7.88953 12.0464 10.9613 12.0464C14.0313 12.0464 16.8266 11.2542 18.9246 9.96822L18.9301 9.96419C19.2376 9.74153 19.6675 9.81028 19.8901 10.1178C20.1128 10.4254 20.044 10.8552 19.7365 11.0778L19.7099 11.0971C19.6961 11.1072 19.6819 11.1167 19.6673 11.1257C17.3273 12.5672 14.2683 13.4214 10.9613 13.4214C7.65415 13.4214 4.6034 12.567 2.26452 11.1256C2.25312 11.1185 2.24193 11.1112 2.23096 11.1035L2.20346 11.0843C1.8924 10.8666 1.81675 10.4378 2.03449 10.1268Z",
    fill: "#F7A303"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82775 6.87712C3.7351 7.85021 3.21094 9.47268 3.21094 12.2382C3.21094 15.0037 3.7351 16.6262 4.82775 17.5992C5.9446 18.5939 7.82625 19.0701 10.9668 19.0701C14.108 19.0701 15.9896 18.5938 17.1063 17.5992C18.1989 16.6262 18.7227 15.0038 18.7227 12.2382C18.7227 9.47258 18.1989 7.85017 17.1063 6.87711C15.9896 5.8825 14.108 5.40625 10.9668 5.40625C7.82625 5.40625 5.9446 5.8825 4.82775 6.87712ZM3.9133 5.85029C5.43507 4.49505 7.77513 4.03125 10.9668 4.03125C14.159 4.03125 16.4991 4.49504 18.0208 5.85031C19.5666 7.22713 20.0977 9.36442 20.0977 12.2382C20.0977 15.1119 19.5666 17.2492 18.0208 18.6261C16.4991 19.9813 14.159 20.4451 10.9668 20.4451C7.77513 20.4451 5.43507 19.9813 3.9133 18.6261C2.36733 17.2492 1.83594 15.112 1.83594 12.2382C1.83594 9.36433 2.36733 7.22708 3.9133 5.85029Z",
    fill: "#F7A303"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28906 4.34434C7.28906 2.87582 8.3767 1.55859 9.86486 1.55859H12.0694C13.5577 1.55859 14.6453 2.87582 14.6453 4.34434V4.92184C14.6453 5.30154 14.3376 5.60934 13.9578 5.60934C13.5781 5.60934 13.2703 5.30154 13.2703 4.92184V4.34434C13.2703 3.49554 12.6657 2.93359 12.0694 2.93359H9.86486C9.26857 2.93359 8.66406 3.49554 8.66406 4.34434V4.92184C8.66406 5.30154 8.35626 5.60934 7.97656 5.60934C7.59687 5.60934 7.28906 5.30154 7.28906 4.92184V4.34434Z",
    fill: "#F7A303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/Jobs.4064e3ee19bd269f47f45f2394f39f37.svg";
export { ForwardRef as ReactComponent };